export function getNavbarDimensions(): { height: number; width: number } {
  const navbar = document.querySelector('.navbar.fixed-top') as HTMLElement;
  return navbar
    ? { height: navbar.offsetHeight, width: navbar.offsetWidth }
    : { height: 0, width: 0 };
}

let originalHeaderStyles: { height: string; width: string } | null = null;

export function applyNavbarDimensionsToHeader(): void {
  const header = document.querySelector('header') as HTMLElement;
  const infoSubNavContainer =
    document.querySelector('.information-sub-nav-container') !== null;

  const inspirationSubNavContainer =
    document.querySelector('.inspiration-sub-nav-container') !== null;

  if (!header) return;

  if (infoSubNavContainer || inspirationSubNavContainer) return;

  if (window.innerWidth > 820) {
    if (!originalHeaderStyles) {
      originalHeaderStyles = {
        height: header.style.height || '',
        width: header.style.width || ''
      };
    }
    const { height, width } = getNavbarDimensions();
    header.style.height = `${height}px`;
    header.style.width = `${width}px`;
  } else if (originalHeaderStyles) {
    header.style.height = '0px';
  }
}
